<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Настройки',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
		return {
			title: 'Настройки',
			items: [],
            user_uuid: '',
            phone: '',
            email: '',
            password: '',
            new_password: '',
            re_new_password: '',
            trackBy: 'id',
            initSMSAllowed: [],
            sms_allowed: null,
            sms_allowed_options: [
                { id: 'true', name: 'Да' },
                { id: 'false', name: 'Нет' },
            ],
            isSubmitErrorData: null,
            isSubmitErrorPassword: null,
            alertMessage: null,
            alertVariant: null
		}
	},

    watch: {
        initSMSAllowed: {
            immediate: true,
            handler(values) {
                this.sms_allowed = this.sms_allowed_options.filter(x => values.includes(x[this.trackBy]));
                this.sms_allowed = this.sms_allowed[0];
            }
        },
    },

	computed: {
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
	},

	async mounted() {
	    this.phone = this.session_user_item.phone;
        this.email = this.session_user_item.email;
        this.sms_allowed = this.session_user_item.sms_allowed;
        this.initSMSAllowed = [this.sms_allowed];
	},

	methods: {

	    async resetAlerts(){
            this.isSubmitErrorData = null;
            this.isSubmitErrorPassword = null;
            this.alertMessage = null;
            this.alertVariant = null;
        },

        async updateUserPassword(){

            let data_send = {
                'uuid'  : this.session_user_item.uuid,
                'password' : this.new_password,
            };

            let result = '';

            if(this.new_password == this.re_new_password){
                result = await this.$store.dispatch('users/FETCH_USERS_UPDATE', data_send);
                if(result === false){
                    this.isSubmitErrorPassword = true;
                    this.alertMessage = 'При обновлении пароля возникла ошибка';
                    this.alertVariant = 'danger';
                } else {
                    this.isSubmitErrorPassword = true;
                    this.alertMessage = 'Пароль успешно обновлен';
                    this.alertVariant = 'success';
                }
            } else {
                this.isSubmitErrorPassword = true;
                this.alertMessage = 'Пароли не совпадают';
                this.alertVariant = 'danger';
            }

        },

        async updateUserData(){

            let data_send = {
                'uuid'  : this.session_user_item.uuid,
                'phone' : this.phone,
                'email' : this.email,
                'sms_allowed' : this.sms_allowed && this.sms_allowed.id ? this.sms_allowed.id : null
            };

            let result = '';

            result = await this.$store.dispatch('users/FETCH_USERS_UPDATE', data_send);

            if(result === false){
                this.isSubmitErrorData = true;
                this.alertMessage = 'При обновлении данных возникла ошибка';
                this.alertVariant = 'danger';
            } else {
                this.isSubmitErrorData = true;
                this.alertMessage = 'Информация успешно обновлена';
                this.alertVariant = 'success';
            }

        }
	},
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-xl-6">
                <div class="card">
                    <b-form
                        @submit.prevent="updateUserData"
                        @click="resetAlerts"
                    >
                    <div class="card-body">
                        <h4 class="mb-3 header-title mt-0">Данные пользователя</h4>

                        <b-alert
                            v-model="isSubmitErrorData"
                            :variant="alertVariant"
                            dismissible
                        >{{ alertMessage }}</b-alert
                        >

                            <b-form-group
                                label="Номер телефона"
                                label-for="phone"
                            >
                                <b-form-input
                                    id="phone"
                                    placeholder="Укажите номер телефона"
                                    v-model="phone"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group
                                label="E-mail адрес"
                                label-for="email"
                            >
                                <b-form-input
                                    id="email"
                                    v-model="email"
                                    placeholder="Укажите e-mail адрес"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group
                                label="Разрешить СМС уведомления"
                                label-for="sms_allowed"
                            >
                                <multiselect
                                    id="sms_allowed"
                                    :track-by="trackBy"
                                    v-model="sms_allowed"
                                    :options="sms_allowed_options"
                                    placeholder="Выберите из списка"
                                    selectLabel="Нажмите, чтобы выбрать"
                                    deselectLabel="Нажмите, снять выделение"
                                    label="name"
                                ></multiselect>
                            </b-form-group>

                    </div>
                    <!-- end card-body-->

                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    </b-form>

                </div>
                <!-- end card-->
            </div>
            <div class="col-xl-6">
                <div class="card">
                    <b-form
                        @submit.prevent="updateUserPassword"
                        @click="resetAlerts"
                    >
                    <div class="card-body">
                        <h4 class="mb-3 header-title mt-0">Смена пароля</h4>

                        <b-alert
                            v-model="isSubmitErrorPassword"
                            :variant="alertVariant"
                            dismissible
                        >{{ alertMessage }}</b-alert
                        >

                            <b-form-group label="Текущий пароль">
                                <b-form-input
                                    type="password"
                                    v-model="password"
                                    placeholder="Укажите текущий пароль"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group label="Новый пароль">
                                <b-form-input
                                    type="password"
                                    v-model="new_password"
                                    placeholder="Укажите новый пароль"
                                ></b-form-input>
                            </b-form-group>

                            <b-form-group label="Повторный пароль">
                                <b-form-input
                                    type="password"
                                    v-model="re_new_password"
                                    placeholder="Повторно укажите новый пароль"
                                ></b-form-input>
                            </b-form-group>
                    </div>

                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    </b-form>
                    <!-- end card-body-->
                </div>
                <!-- end card-->
            </div>
        </div>
	</Layout>
</template>
